import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'
import { toFilterOptions } from '@util/filter'

import { useStatusConfig } from '../../../status/hooks/useStatusConfig'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useHoofdleidingValuelists } from '../../../valuelists/hooks/useHoofdleidingValuelists'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { AssignedBijlagenFilters } from '../components/AssignedBijlagenFilters'
import { AssignedBijlagenTableRow } from '../components/AssignedBijlagenTableRow'
import { useAssignedBijlagenSearch } from '../hooks/useAssignedBijlagenSearch'

const headerCells = [
  { id: 'expired', numeric: false, label: '', fixed: 25 },
  { id: 'documentsoort', numeric: false, label: 'Documentsoort', fixed: 200 },
  {
    id: 'dueWeek',
    numeric: false,
    label: 'Opleveren voor',
    fixed: 100,
    sort: true,
  },
  {
    id: 'created.date',
    numeric: false,
    label: 'Aangemaakt',
    fixed: 50,
    sort: true,
  },
  {
    id: 'created.organisatie',
    numeric: false,
    label: 'Aangemaakt door',
    fixed: 100,
    sort: true,
  },
  {
    id: 'assignedTo',
    numeric: false,
    label: 'Toegewezen aan',
    fixed: 150,
    sort: true,
  },
  { id: 'entity', numeric: false, label: 'Horend bij', fixed: 75, sort: true },
  { id: 'gemeente', numeric: false, label: 'Gemeente', fixed: 125 },
  { id: 'gebiedscode', numeric: false, label: 'Gebied & labels', fixed: 100 },
  { id: 'actions', numeric: false, label: 'Details', fixed: 75 },
] as const

export const AssignedBijlagen = () => {
  const { data: valuelists } = useValuelists()
  const { data: hoofdleidingValuelists } = useHoofdleidingValuelists()
  const { data: statusConfig } = useStatusConfig()
  const {
    data: { items: assignedBijlagen, count, skip, limit },
    initialFilters,
    isLoading,
    isError,
    filters,
    onChangeFilters,
    onChangePage,
    onChangeSort,
    sort,
    onRefresh,
    onReset,
  } = useAssignedBijlagenSearch()

  return (
    <Page
      title={['Bijlagen', 'Hoofdleiding']}
      breadcrumbs={[
        { label: 'Hoofdleiding', href: '/home', tooltip: 'CAPO home' },
        { label: 'Bijlagen' },
      ]}
      fillScreen
    >
      <PageSection id="bijlagen" heading="Overzicht van uw bijlagen" />

      <Paper>
        <AssignedBijlagenFilters
          filters={filters}
          initialFilters={initialFilters}
          onChange={onChangeFilters}
          onRefresh={onRefresh}
          onReset={onReset}
          filterOptions={{
            ...valuelists,
            hoofdleiding: hoofdleidingValuelists,
            labels: toFilterOptions(hoofdleidingValuelists.labels),
            processtappen: statusConfig.processtappenHoofdleiding,
          }}
        />
        <StyledTable
          headerCells={headerCells}
          loading={isLoading}
          onChangePage={onChangePage}
          onChangeSort={onChangeSort}
          sort={sort}
          stats={{ count, skip, limit }}
          isError={isError}
        >
          {assignedBijlagen.map((assignedBijlage) => {
            return (
              <AssignedBijlagenTableRow
                assignedBijlage={assignedBijlage}
                key={assignedBijlage._id}
              />
            )
          })}
        </StyledTable>
      </Paper>
    </Page>
  )
}
